
import { React, useEffect, useState } from 'react';
import { Button, Form, Alert } from 'react-bootstrap/';
import LoadingIndicator from '../Loading';
import './Form.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

// props are promo code id, props.codeId
const InfoForm = (props) => {

  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [selectedOption, setSelectedOption] = useState();
  const [addressInput, setAddressInput] = useState();



  const SmartySDK = require("smartystreets-javascript-sdk");
  const SmartyCore = SmartySDK.core;
  const Lookup = SmartySDK.usAutocompletePro.Lookup;

  // US Autocomplete Pro only supports using Embedded Keys
  let key = process.env.REACT_APP_SMARTY_EMBEDDED_KEY;
  const credentials = new SmartyCore.SharedCredentials(key);

  // The appropriate license values to be used for your subscriptions
  // can be found on the Subscription page of the account dashboard.
  // https://www.smarty.com/docs/cloud/licensing
  let clientBuilder = new SmartyCore.ClientBuilder(credentials).withLicenses(["us-autocomplete-pro-cloud"]);
  // .withBaseUrl("");
  let client = clientBuilder.buildUsAutocompleteProClient();


  useEffect(() => {
    if (selectedOption !== undefined) {

      setFormData({ ...formData, city: selectedOption.city, state: selectedOption.state, postal: selectedOption.zipcode })
    }
  }, [selectedOption])

  const [options, setOptions] = useState([])
  const autoComplete = async (lookup) => {
    await handleRequest(lookup, "Simple Lookup");
  }

  async function handleRequest(lookup, lookupType) {
    try {
      if (process.env.REACT_APP_SMARTY_EMBEDDED_KEY != null || process.env.REACT_APP_SMARTY_EMBEDDED_KEY || undefined) {
        const results = await client.send(lookup);
        let temp = results.result;
        temp.forEach((element) => {
          // element.label = element.streetLine;
          element.key = `${element.streeLine}${element.city}${element.state}}`
        });
        setOptions([...temp])
      }

    } catch (err) {
      console.log("There was an error with address request")
    }
  }

  // submit form
  const submitForm = async (event) => {
    event.preventDefault();
    if (!isPOAddress()) {
      let data = event.target;

      // hacky way to remove the city and state from the label that is displayed when the user selects an address
      // probably a better way to do this but it works

      let street = ""

      for (let i = 0; i < data[4].value.length; i++) {
        if (data[4].value[i] === ',') {
          break;
        } else {
          street += data[4].value[i];
        }
      }

      var jsonObject = {
        email: data[2].value,
        first_name: data[0].value,
        last_name: data[1].value,
        phone: data[3].value,
        street: street,
        city: data[5].value,
        state: data[6].value,
        postal: data[7].value,
      }

      // Results can be: 

      // {
      //    'success': true
      //  }
      //   {
      //     "success": false,
      //     "error": "user test error code",
      //     "error_code": 0
      // }
      //   {
      //     "success": false,
      //     "error": "internal test error code",
      //     "error_code": 99
      // }

      // https://jfh5w19m1b.execute-api.us-east-1.amazonaws.com/promo_code_error_for_internal/${props.codeId}
      // https://jfh5w19m1b.execute-api.us-east-1.amazonaws.com/promo_code_error_for_user/${props.codeId}
      // https://jfh5w19m1b.execute-api.us-east-1.amazonaws.com/promo_code/${props.codeId}

      try {
        setSubmitted(true);
        await fetch(`https://jfh5w19m1b.execute-api.us-east-1.amazonaws.com/promo_code/${props.codeId}`, {
          method: 'POST',
          body: JSON.stringify(jsonObject)
        }).then(response => response.json())
          .then(data => {
            if (data['success'] && data['success'] === true) {
              return
            } else {
              if (data['error_code'] === 0) {
                setError(data['error'])
              } else {
                setError(`An Error Occured[Error Code: ${data['error_code']}]`)
              }
            }
          });

      } catch (error) {
        setError("An Unknown Error Occured");
      }
      setLoading(false);
    } else {
      alert("Sorry, we do not ship to PO Boxes")
    }
  }

  // Message shown after submission
  const submitMessage = () => {
    const invalid = error !== "";
    return (
      <>
        <Alert variant={invalid ? 'danger' : 'success'}>
          <Alert.Heading>{invalid ? 'Oh no! Something went wrong with your submission' : 'Thanks for your submission!'}</Alert.Heading>
          <hr />
          <p>
            {invalid ? error : 'You should be receiving an email from us shortly for confirmation.'}
          </p>
        </Alert>
      </>
    )
  }

  const isPOAddress = () => {
    if (addressInput != null) {
      var pattern = new RegExp('\\b[p]*(ost)*\\.*\\s*[o|0]*(ffice)*\\.*\\s*b[o|0]x\\b', 'i');
      if (addressInput.match(pattern)) {
        return true;
      }
      return false;
    }
    return false;
  }

  // The actual form that is displayed
  const formFields = () => {
    return (
      <Form className='formContainer'
        onSubmit={submitForm}
      >

        <div className='innerFormContainer'>
          <div className='formSideContainer'>
            {/* FIRST NAME */}
            <TextField
              variant='standard'
              className='formControl'
              required
              type="text"
              placeholder="First Name" />
            {/* LAST NAME */}
            <TextField
              variant='standard'
              className='formControl'
              required
              type="text"
              placeholder="Last Name" />
            {/* EMAIL */}
            <TextField
              variant='standard'
              className='formControl'
              required
              type="email"
              placeholder="Enter email" />
            {/* Phone */}
            <TextField
              variant='standard'
              className='formControl'
              required
              type="text"
              placeholder="Phone Number" />
          </div>

          {/* ********************* ADDRESS  ************************* */}
          <div className='formSideContainer'>

            {/* Street */}

            <Autocomplete
              freeSolo={true}
              disableClearable
              getOptionLabel={(option) =>
                typeof option === 'string' ? option : `${option.streetLine}, ${option.city}, ${option.state}`
              }
              className='formControl'
              options={options}
              value={selectedOption}
              onChange={(e, newOption) => {
                setSelectedOption(newOption)
                setAddressInput(newOption);
              }}
              onInputChange={async (e, newValue) => {
                setAddressInput(newValue);
                if (newValue.length > 3) {

                  let lookup = new Lookup(newValue);
                  lookup.maxResults = 5;
                  await autoComplete(lookup);
                  // }
                  setFormData({ ...formData, street: newValue })
                }
              }
              }
              renderInput={(params) =>
                <TextField
                  variant='standard'
                  {...params}
                  required
                  error={isPOAddress()}
                  helperText={isPOAddress() ? "We do not ship to PO Boxes" : ""}
                  type="text"
                  placeholder="Street" />}
            />


            {/* City */}
            <TextField
              variant='standard'
              className='formControl'
              required
              value={formData['city']}
              type="text"
              placeholder="City" />

            {/* State */}
            <TextField
              variant='standard'
              className='formControl'
              required
              value={formData['state']}
              type="text"
              placeholder="State" />

            {/* Postal */}
            <TextField
              variant='standard'
              className='formControl'
              required
              value={formData['postal']}
              type="text"
              placeholder="Postal" />
          </div>
        </div>
        <Button
          type="submit"
          variant="primary"
          className='formBtn'
        > SUBMIT</Button>
        <small style={{ marginTop: '1em', fontStyle: 'italic', color: 'grey' }}>We do not ship to PO Boxes</small>
      </Form>
    )
  }

  return (
    < div >
      {loading ? <LoadingIndicator /> :
        submitted ? submitMessage() : formFields()
      }
    </ div >
  );
}

export default InfoForm;